module.exports = __webpack_public_path__ + "img/ac7.efe897d6.png";